import {
  FNOL_AvailabilityResponse,
  FNOL_ClaimOwnerOrComplexAvailabilityResponse,
  FNOL_Request,
  FNOL_TaskTypes,
} from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';
import { intakeAvailability } from '@dispatch/shared/services';

export const useFnolRequest = (
  responseFn: (response: {
    data:
      | FNOL_AvailabilityResponse
      | FNOL_ClaimOwnerOrComplexAvailabilityResponse;
    success: boolean;
  }) => void | Promise<unknown>
) => {
  const { mutate, error, status } = useMutate(
    ['fnol-request'],
    (data: { request: FNOL_Request; taskType: FNOL_TaskTypes }) =>
      intakeAvailability(data.request, data.taskType),
    (response) => {
      responseFn(
        response as {
          data:
            | FNOL_AvailabilityResponse
            | FNOL_ClaimOwnerOrComplexAvailabilityResponse;
          success: boolean;
        }
      );
    }
  );

  return {
    fnolRequest: mutate,
    error,
    status,
  };
};
